'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { FINDER_PROJECTS_SET_ACTIVE_PROJECT_FOLDER_ID, FINDER_PROJECTS_DEPLOY_REQUEST, FINDER_PROJECTS_DEPLOY_RECEIVE, FINDER_PROJECTS_DEPLOY_ERROR, FINDER_PROJECTS_CREATE_REQUEST, FINDER_PROJECTS_CREATE_RECEIVE, FINDER_PROJECTS_CREATE_ERROR, PROJECTS_STAGED_FILES_RECEIVE } from 'DesignData/actions/ActionTypes';
export default function Projects(state = SeamlessImmutable({
  activeProjectFolderId: null,
  projectCreationInProgress: false,
  projectDeploymentInProgress: false,
  stagedFilesByPath: {}
}), action) {
  switch (action.type) {
    case FINDER_PROJECTS_SET_ACTIVE_PROJECT_FOLDER_ID:
      {
        const id = action.folderId || null;
        return SeamlessImmutable.set(state, 'activeProjectFolderId', id);
      }

    case FINDER_PROJECTS_CREATE_REQUEST:
      {
        return Object.assign({}, state, {
          projectCreationInProgress: true
        });
      }

    case FINDER_PROJECTS_CREATE_RECEIVE:
    case FINDER_PROJECTS_CREATE_ERROR:
      {
        return Object.assign({}, state, {
          projectCreationInProgress: false
        });
      }

    case FINDER_PROJECTS_DEPLOY_REQUEST:
      {
        return Object.assign({}, state, {
          projectDeploymentInProgress: true
        });
      }

    case FINDER_PROJECTS_DEPLOY_RECEIVE:
    case FINDER_PROJECTS_DEPLOY_ERROR:
      {
        return Object.assign({}, state, {
          projectDeploymentInProgress: false
        });
      }

    case PROJECTS_STAGED_FILES_RECEIVE:
      {
        return Object.assign({}, state, {
          stagedFilesByPath: Object.assign({}, state.stagedFilesByPath, {
            [action.projectPath]: action.stagedFiles
          })
        });
      }

    default:
      return state;
  }
}